import React from 'react'
import { useState,useEffect} from 'react';
import{Container,Grow, Grid,Paper,AppBar,TextField,Button } from '@material-ui/core';
import Posts from '../Posts/Posts';
import Form from '../Form/Form';
import useStyles from './styles';
import Pagination from '../Pagination';
import { getPosts,getPostsBySearch } from '../../actions/posts';
import {useDispatch} from 'react-redux';
import {useNavigate,useLocation} from 'react-router-dom';
import ChipInput from 'material-ui-chip-input';

function useQuery(){
  return new URLSearchParams(useLocation().search);
}
const Home = () => {
    const classes = useStyles();
   
    
    const[currentId,setCurrentId] = useState(null);
    const dispatch = useDispatch();
    const query = useQuery();
    const navigate = useNavigate();
    const page = query.get('page') || 1 ;
    const searchQuery = query.get('searchQuery');
    const [search,setSearch] = useState('');
    const [tags, setTags] = useState([]);
    
    const handleAdd  = (tag) => setTags([...tags,tag]);
    const handleDelete = (tagToDelete) => setTags(tags.filter((tag)=>tag!== tagToDelete));
   
    const handleKeyPress = (e)=> {
      if(e.keyCode ===13){
        searchPost();
      }
    }
    const searchPost = ()=>{
      if(search.trim().length>0||tags.length>0){
        dispatch(getPostsBySearch({search,tags:tags.join(',')}));
        navigate(`/posts/search?searchQuery=${search || 'none'}&tags=${tags.join(',')}`);
      }
      else{
        navigate('/')
;      }
    }
  return (
    <Grow in>
    <Container maxWidth='xl'>
      <Grid container className={classes.gridContainer}  justifyContent='space-between' alignItems='stretch' spacing={3}>
          <Grid  item xs={12} sm={6} md={9}>
              <Posts setCurrentId={setCurrentId}/>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <AppBar className={classes.appBarSearch} position='static' color='inherit'>
              <TextField
               name='search'
               variant='outlined'
               label='Search Memories'
               onKeyPress={handleKeyPress}
               fullWidth
               value={search}
               onChange={(e)=>{setSearch(e.target.value)}}
              />
              <ChipInput
                style={{margin:'10px 0'}}
                value = {tags}
                onAdd = {handleAdd}
                onDelete = {handleDelete}
                label = 'searchTags'
                variant = 'outlined'
                newChipKeyCodes={[32]}

              />
              <Button variant='contained' onClick={searchPost} className={classes.searchButton} color='primary'>Search</Button>
            </AppBar>
              <Form currentId={currentId} setCurrentId={setCurrentId}/>
              {(!searchQuery && !tags.length)&&(
              <Paper  elevation={6} className={classes.pagination}>
                  <Pagination page={page}/>
              </Paper>
              )}

          </Grid>
      </Grid>
    </Container>
  </Grow>
  )
}

export default Home
